import { VyDivider } from '../../../../../../components/new-design/atoms';
import { Box, Button, Stack, Typography } from '@mui/material';
import { isNotNullOrUndefined } from '@vy/utils';
import { FC, ReactNode } from 'react';
import { VyPaper } from '../../../../../../components/new-design/data-display/VyPaper/VyPaper.tsx';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

type ContractStatCardNavLink = {
  label: string;
  value?: ReactNode;
  onClick: () => void;
  selector?: string;
};

type ContractStatCardProps = {
  cardLabel: string;
  cardHeaderAdditionalContent?: ReactNode;
  children?: ReactNode;
  mainValue: ReactNode;
  subItems: ReactNode[];
  navLinks?: ContractStatCardNavLink[];
  cta?: {
    label?: string;
    text: string;
    onClick: () => void;
  };
};

export const ContractStatCard: FC<ContractStatCardProps> = ({
  cardLabel,
  cardHeaderAdditionalContent,
  mainValue,
  subItems,
  children,
  navLinks,
  cta,
}) => {
  const isCtaHasLabel = isNotNullOrUndefined(cta?.label);

  return (
    <VyPaper sx={{ height: '100%', padding: '22px 20px' }}>
      <Stack divider={<VyDivider />} spacing={2.5}>
        <Box>
          <Stack direction="row" sx={{ justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
            <Typography variant="body2">{cardLabel}</Typography>

            {isNotNullOrUndefined(cardHeaderAdditionalContent) && cardHeaderAdditionalContent}
          </Stack>
          <Typography variant="h4">{mainValue}</Typography>
          <Stack
            direction="row"
            spacing={2}
            divider={<VyDivider orientation="vertical" flexItem />}
            sx={{ gap: '6px' }}
          >
            {subItems.map((subItem, index) => (
              <Typography key={index} variant="body2" sx={{ color: '#7E8796', lineHeight: '20px' }}>
                {subItem}
              </Typography>
            ))}
          </Stack>
        </Box>
        {isNotNullOrUndefined(children) && <Box>{children}</Box>}

        {navLinks?.map((navLink, index) => (
          <Stack
            key={index}
            direction="row"
            role="button"
            onClick={navLink.onClick}
            data-vy={navLink.selector}
            sx={{ justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}
          >
            <Typography sx={{ fontSize: '12px', lineHeight: '16px', color: '#5F6978' }}>
              {navLink.label}
            </Typography>
            <Stack direction="row" sx={{ alignItems: 'center', gap: '4px', minWidth: 0, maxWidth: '70%' }}>
              {isNotNullOrUndefined(navLink.value) && (
                <Typography noWrap sx={{ minWidth: 0, fontSize: '14px', lineHeight: '20px', color: '#020F20' }}>
                  {navLink.value}
                </Typography>
              )}
              <ArrowForwardIcon sx={{ fontSize: '20px', color: '#020F20' }} />
            </Stack>
          </Stack>
        ))}

        {isNotNullOrUndefined(cta) && (
          <Stack direction="row" sx={{ justifyContent: isCtaHasLabel ? 'space-between' : 'flex-end' }}>
            {isCtaHasLabel && (
              <Typography variant="body2" color="text.secondary">
                {cta.label}
              </Typography>
            )}
            <Button variant="text" onClick={cta.onClick} endIcon={<ArrowForwardIcon />}>
              {cta.text}
            </Button>
          </Stack>
        )}
      </Stack>
    </VyPaper>
  );
};
